import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { CreditCard, FileText } from 'lucide-react';

import type { MatchInquiryReportData } from '../types';
import { MatchProvidedDetailsSection } from '../components/MatchProvidedDetailsSection';
import { MatchResultsSection } from '../components/MatchResultsSection';

type MatchInquirySection = {
  id: string;
  title: string;
  Icon?: LucideIcon;
  Component: ReactNode;
  isHidden: boolean;
};

export const useMatchInquiryReportSections = (
  data: MatchInquiryReportData,
): { sections: MatchInquirySection[] } => {
  const { summary, terminatedMatches, providedDetails } = data;

  const sections = useMemo(() => {
    const allSections = [
      {
        id: 'match-results',
        title: 'MATCH Results',
        Icon: CreditCard,
        isHidden: false,
        Component: <MatchResultsSection summary={summary} terminatedMatches={terminatedMatches} />,
      },
      {
        id: 'provided-details',
        title: 'Provided Details',
        Icon: FileText,
        isHidden: !providedDetails,
        Component: <MatchProvidedDetailsSection providedDetails={providedDetails} />,
      },
    ] satisfies MatchInquirySection[];

    return allSections.filter(section => !section.isHidden);
  }, [summary, terminatedMatches, providedDetails]);

  return { sections };
};
